import moment from 'moment'
import 'moment/locale/pt-br'

const format = (date, format = 'L', origin = null) =>
  moment.parseZone(date, origin).format(format)

const now = (format = 'L') => moment().format(format)

const isPast = date => moment().isAfter(moment(date))

export default { format, now, isPast }
